import { Link } from "react-router-dom";
import { ArrowRight, Globe, Megaphone, Clapperboard } from "lucide-react";

const ITEMS = [
  { icon: Globe, t: "Neue Homepage — Festpreis ab 1.990 €" },
  { icon: Megaphone, t: "Google Ads & Werbung — an jedes Budget anpassbar" },
  { icon: Clapperboard, t: "Videos & Instagram-Anzeigen — wenn gewünscht" },
];

export const ServicesTeaser = () => (
  <section data-testid="services-teaser" className="border-y border-sand-800/10" style={{ backgroundColor: "#2E2A26" }}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-14 grid lg:grid-cols-[1.2fr_1fr] gap-8 items-center">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <span className="h-px w-10 bg-brand-rose" />
          <span className="font-poster text-[11px] uppercase tracking-[0.3em] font-medium text-brand-rose">
            Für Pflegedienste
          </span>
        </div>
        <h2 className="font-magazine text-3xl md:text-4xl text-cream-50 leading-tight">
          Veraltete Homepage, kaum Anfragen? <em className="italic text-brand-rose">Das lösen wir schnell.</em>
        </h2>
        <Link
          to="/services"
          data-testid="services-teaser-cta"
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-brand-rose text-espresso-deep font-semibold text-sm px-6 py-3 hover:brightness-105 transition"
        >
          Mehr erfahren <ArrowRight className="h-4 w-4" strokeWidth={1.8} />
        </Link>
      </div>
      <div className="space-y-3">
        {ITEMS.map(({ icon: Icon, t }) => (
          <div key={t} className="flex items-center gap-3 rounded-xl border border-cream-100/15 bg-cream-100/5 px-4 py-3.5">
            <Icon className="h-4.5 w-4.5 text-brand-rose shrink-0" strokeWidth={1.7} />
            <span className="text-cream-100/90 text-[13.5px] font-medium">{t}</span>
          </div>
        ))}
      </div>
    </div>
  </section>
);
